// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

export const SUPABASE_URL = "https://zomlivqodrcwfazergfa.supabase.co";
export const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpvbWxpdnFvZHJjd2ZhemVyZ2ZhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMzNDI2NjgsImV4cCI6MjA2ODkxODY2OH0.zyrNvHnGflUsMbns9z6q5VFtA-NY8qRzL2_0FPeeECE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});